module.exports = __webpack_public_path__ + "fonts/SimplerPro_Alte-Black.69dd7f11.otf";